import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

const defaultPage = 1;
const defaultPageSize = 10;
const defaultTotalCount = 100;

@Component({
    selector: 'app-dynamic-data-list-pagination',
    templateUrl: './dynamic-data-list-pagination.component.html',
    standalone: false
})
export class DynamicDataListPaginationComponent implements OnChanges {
  @Input() page: number = defaultPage;
  @Input() useUrlParameters: boolean;
  @Input() pageSize: number = defaultPageSize;
  @Input() totalCount: number = defaultTotalCount;
  @Output() pageChange = new EventEmitter<number>();

  private _lazyLoadingPagination;
  get lazyLoadingPagination(): boolean {
    return this._lazyLoadingPagination;
  }
  @Input() set lazyLoadingPagination(lazyLoadingPagination: boolean) {
    if (this._lazyLoadingPagination === lazyLoadingPagination) return;

    this._lazyLoadingPagination = lazyLoadingPagination;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.lazyLoadingPagination && this.useUrlParameters) {
      if (!this.queryParamsSubscription && this.useUrlParameters) {
        this.queryParamsSubscription = new Subscription();
        this.queryParamsSubscription.add(this.queryParams$.subscribe(() => {}));
      }
    }
  }

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.queryParams$ = this.activatedRoute.queryParams.pipe(
      tap((queryParams) => {
        const { page } = queryParams;
        const pageNumber = Number(page);
        if (!isNaN(pageNumber) && this.page !== pageNumber) {
          this.page = pageNumber;
          this.pageChange.emit(this.page);
        }
      })
    );
  }

  paginationMaxSize: number = 10;
  queryParams$: Observable<Params>;
  queryParamsSubscription: Subscription;

  onPageChange(pageNo: number) {
    if (this.useUrlParameters) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { page: pageNo, perpage: this.pageSize },
        queryParamsHandling: 'merge',
      });
    }

    this.page = pageNo;
    this.pageChange.emit(pageNo);
  }
}
